import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ImageGalleryComponent } from './image-gallery.component';
import { ImageContainerComponent } from './image-container/image-container.component';
import { CustomMaterialModule } from '@sk/custom-material';

@NgModule({
  declarations: [
    ImageGalleryComponent,
    ImageContainerComponent
  ],
  imports: [
    CommonModule,
    CustomMaterialModule,
    FlexLayoutModule,
  ],
  exports: [ImageGalleryComponent, ImageContainerComponent]
})
export class ImageGalleryModule {
}
